import Joi from 'joi-browser';
import PeriodPageModal from '../containers/PeriodPageModal';
const dateFormat = 'MM/DD/YYYY HH:mm';

export function getPeriodConfig() {
    return {
        scope: 'company',
        actionEdit: true,
        actionDelete: true,
        empty: {
            periodStartdate: "",
            periodEnddate: "",
            enrollmentStartDate: "",
            enrollmentEndDate: "",
            stockPrice: ""
        },
        fieldTypes: {
            periodStartdate: {
                fieldName: "Period Start date",
                type: 'date',
                dateformat: dateFormat,
                required: true,
                prepopulate: true,
                noneditable: false
            },
            periodEnddate: {
                fieldName: "Period End date",
                type: 'date',
                dateformat: dateFormat,
                required: true,
                prepopulate: true,
                noneditable: false
            },
            enrollmentStartDate: {
                fieldName: "Enrollment Start date",
                type: 'date',
                dateformat: dateFormat,
                prepopulate: true,
                noneditable: false,
                required: true
            },
            enrollmentEndDate: {
                fieldName: "Enrollment End date",
                type: 'date',
                dateformat: dateFormat,
                prepopulate: true,
                noneditable: false,
                required: true
            },
            stockPrice: {
                fieldName: "Stock Price",
                type: 'currency',
                prepopulate: true,
                noneditable: false,
                required: false
            }
        },
        validationSchema: Joi.object().keys({
            id: Joi.string(),
            enrollmentStartDate: Joi.date(),
            enrollmentEndDate: Joi.date().min(Joi.ref('enrollmentStartDate')),
            periodStartdate: Joi.date(),
            periodEnddate: Joi.date(),
            companyId: Joi.string(),
            stockPrice: Joi.number(),
        }).unknown(true),
        actions: [{
            title: 'Edit',
            action_type: 'edit',
            icon: (period) => period.stockPrice ? null : 'edit',
        }, {
            title: 'Close period',
            action_type: 'modal',
            icon: (period) => period.stockPrice ? 'locked' : 'unlocked',
            enabled: (period) => period.periodEnddate < new Date(),
            modal_component: PeriodPageModal
        }]
    }
}